import {
    HTML_VIDEO_ENCODING_FORMAT,
    HTML_VIDEO_PRESET,
    HTML_VIDEO_PRESET_METADATA
} from "shared-utils/enums/htmlVideoExport";

import {
    PlainlyEncodingFormat,
    PlainlyOutputModule,
    PlainlyPostEncoding
} from "@/utils/CreativeIntelligenceApi/plainly-options";

export const DEFAULT_OUTPUT_MODULE = "DEFAULT_AE_SETTINGS";
export const FPS_OPTIONS = [24, 25, 30, 60];
export const DEFAULT_HTML_VIDEO_FPS = 60;

export const HTML_VIDEO_PRESET_OPTIONS = Object.values(HTML_VIDEO_PRESET).map(value => ({
    value,
    label: HTML_VIDEO_PRESET_METADATA[value].label,
    description: HTML_VIDEO_PRESET_METADATA[value].description
}));

export const HTML_VIDEO_ENCODING_FORMAT_OPTIONS = [
    { label: "MP4", value: HTML_VIDEO_ENCODING_FORMAT.MP4 },
    { label: "MOV", value: HTML_VIDEO_ENCODING_FORMAT.MOV }
];
export const OUTPUT_MODULE_OPTIONS = [
    {
        label: "Default After Effects Settings",
        value: DEFAULT_OUTPUT_MODULE
    },
    {
        label: "H.264 - Match Render Settings - 5 Mbps",
        value: PlainlyOutputModule.H_264
    },
    {
        label: "H.264 - Match Render Settings - 15 Mbps",
        value: PlainlyOutputModule.H_264_HIGH_BIT_RATE
    },
    {
        label: "High Quality",
        value: PlainlyOutputModule.HQ
    },
    {
        label: "High Quality with Alpha",
        value: PlainlyOutputModule.HQ_ALPHA
    }
];
export const POST_ENCODING_OPTIONS = [
    {
        label: "Default",
        value: PlainlyPostEncoding.DEFAULT
    },
    {
        label: "None",
        value: PlainlyPostEncoding.NONE
    },
    {
        label: "Smallest",
        value: PlainlyPostEncoding.SMALLEST
    },
    {
        label: "Scale",
        value: PlainlyPostEncoding.SCALE
    },
    {
        label: "Custom",
        value: PlainlyPostEncoding.CUSTOM
    }
];

export const ENCODING_FORMAT_OPTIONS = [
    { label: "MP4", value: PlainlyEncodingFormat.MP4 },
    { label: "GIF", value: PlainlyEncodingFormat.GIF },
    { label: "OGG", value: PlainlyEncodingFormat.OGG },
    { label: "WEBM", value: PlainlyEncodingFormat.WEBM },
    { label: "MOV", value: PlainlyEncodingFormat.MOV },
    { label: "MP4 H.265", value: PlainlyEncodingFormat.MP4_H265 },
    { label: "MXF", value: PlainlyEncodingFormat.MXF }
];
